import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email.trim()) {
      setError('Informe seu email.');
      return;
    }
    setSent(true);
  };

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-white">
      <div className="flex-1 flex flex-col justify-center px-6 py-10 md:px-12 lg:px-16">
        <div className="w-full max-w-md mx-auto">
          <Link to="/login" className="inline-flex items-center text-gray-600 hover:text-gray-800 mb-8">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M15 18L9 12L15 6" />
            </svg>
            <span className="ml-2">Voltar</span>
          </Link>

          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 rounded-full border-2 border-orange-500 flex items-center justify-center bg-white">
              <span className="text-orange-600 font-bold text-xl">N</span>
            </div>
            <div>
              <span className="text-gray-800 font-bold text-lg block">NAVI</span>
              <span className="text-gray-500 text-sm block">EXPERIENCE</span>
            </div>
          </div>

          <h1 className="text-gray-800 text-2xl font-semibold mb-2">Recuperar senha</h1>
          <p className="text-gray-600 text-sm mb-6">
            Informe seu email e enviaremos um link para redefinir sua senha.
          </p>

          {error && (
            <p className="text-red-600 text-sm mb-4 bg-red-50 py-2 px-4 rounded-lg border border-red-200">
              {error}
            </p>
          )}

          {sent ? (
            <div className="space-y-4">
              <p className="text-gray-700 text-sm bg-green-50 py-4 px-4 rounded-xl border border-green-200">
                Se este email estiver cadastrado, você receberá um link para redefinir sua senha. Verifique sua caixa de entrada.
              </p>
              <Link
                to="/login"
                className="inline-block w-full py-3 px-6 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-lg font-semibold text-center hover:opacity-95"
              >
                Voltar ao login
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="email" className="block text-gray-700 text-sm font-medium mb-1">
                  E-mail
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="seu@email.com"
                  className="w-full py-3 px-4 bg-gray-50 text-gray-800 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent"
                  required
                />
              </div>

              <button
                type="submit"
                className="w-full py-3 px-6 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-lg font-semibold shadow-lg hover:shadow-xl transition-all hover:opacity-95"
              >
                Enviar link
              </button>

              <div className="text-center">
                <Link to="/login" className="text-sm text-orange-600 font-semibold hover:underline">
                  Voltar ao login
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>

      <div className="hidden md:block md:w-[45%] lg:w-1/2 min-h-screen relative bg-gray-100">
        <img
          src="https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=1200&q=80"
          alt="Paisagem"
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>
    </div>
  );
}
